import type { FaireProductEntity } from "../../entity_types/product";

export const p_cwqnuvnzyb: FaireProductEntity = {
  token: "p_cwqnuvnzyb",
  type: "product",
  name: "Liquid Xanax | Liquid Calm | Anxiety Panic Attack Natural Relief | Essential Oil Roll on Steel Ball Roller Bottle |  Calming Relaxing Organic |Woman Owned",
  brandToken: "b_6r1eum8lfs",
  brandName: "Wonderfully Made .love",
  imageUrl:
    "https://cdn.faire.com/fastly/b3bd0941a1001e9cbb27316e392438b2655713a7babe1aa217d0e1befaabe69d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f292b6f434a9be20da3b2ad8892b70e373c080c75e1bd4d79617f6a8812b648.jpeg",
    "https://cdn.faire.com/fastly/9db43f18c92c63f136adf46346737df158fcd52464b1182fa8a92b777212eee5.jpeg",
  ],
  priceDollars: 13.3,
  description:
    "We can ALL use this blend!! It is a customer favorite, and for good reason!! Roll on inner wrists, and temples, take a few deep breaths, and you'll be instantly calmed and grounded. No more smothering under anxiety or panic attacks. Smells great too!! Keep this handy roller with you everywhere you go!\n\nContains a science-tested synergistic blend of organic essential oils, with organic coconut oil to help glide the essential oils along your skin. \n\nComes in a 10ml glass bottle, with a glass or metal roller ball. If you have any questions, feel free to contact me!\n\nThank you for supporting a mother in TN!\n\nNot FDA approved to diagnosis, treat, or cure any disease.\n",
  tags: [],
  msrpDollars: 22.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:40.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
